"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const env_1 = require("../../helpers/env");
/**
 * Note: I believe this only works for 'request-guard' auth'd apps.
 *
 * @see the documentation for the `enableLogout` prop of ProfileMenu
 */
const createLogoutURI = () => {
    const appRedirectUri = `${location.origin}/auth/sign_out`;
    if (env_1.IS_DEV)
        return appRedirectUri;
    const keycloakRealm = env_1.IS_PROD ? 'services' : 'sandbox';
    const keycloakHost = env_1.IS_PROD
        ? 'authentication.managed.services.opendoor.com'
        : 'authentication-staging.managed.services.opendoor.com';
    const logoutEndpoint = `https://${keycloakHost}/auth/realms/${keycloakRealm}/protocol/openid-connect/logout`;
    return `${logoutEndpoint}?redirect_uri=${encodeURIComponent(appRedirectUri)}`;
};
/**
 * Displays the name of the currently logged-in user.
 *
 * Optionally displays a "Logout" link and a custom list of `MenuItems` in a dropdown after clicking the User's name.
 */
const ProfileMenuView = ({ name = '', enableLogout = false, menuItems = [], }) => {
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const hasMenuItems = enableLogout || menuItems.length > 0;
    const handleOpen = react_1.useCallback((event) => setAnchorEl(event.currentTarget), [setAnchorEl]);
    const handleClose = react_1.useCallback(() => setAnchorEl(null), [setAnchorEl]);
    const handleLogoutClick = react_1.useCallback(() => {
        if (env_1.IS_DEV) {
            // There's no way to un-authenticate localhost
            alert("You can't logout in development");
        }
        // Request-guard auth'd apps all expose this url, which expires the current token
        window.location.assign(createLogoutURI());
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Button, { "aria-controls": "simple-menu", "aria-haspopup": "true", className: 'pa-0 ' + clsx_1.default('bg-transparent', { 'pointer-events-none': !hasMenuItems }), variant: "text", onClick: hasMenuItems ? handleOpen : undefined },
            react_1.default.createElement(core_1.Avatar, { className: "w-3 h-3 fs-7" }, name[0]),
            name && (react_1.default.createElement(core_1.Typography, { className: "pl-3", variant: "body1" }, name))),
        react_1.default.createElement(core_1.Menu, { open: !!anchorEl, anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, anchorPosition: {
                // These, along with the PaperProps.style.width make the dropdown appear as wide as the anchorEl
                top: (anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.offsetTop) || 0,
                left: (anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.offsetLeft) || 0,
            }, PaperProps: {
                style: {
                    minWidth: (anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.offsetWidth) + 'px',
                    marginTop: '8px',
                },
            }, keepMounted: true, onClose: handleClose },
            menuItems,
            enableLogout && react_1.default.createElement(core_1.MenuItem, { onClick: handleLogoutClick }, "Logout"))));
};
exports.default = ProfileMenuView;
